<div class="d-flex flex-column">
	<label class="text-tertiary w-100 text-center fw-semibold mt-3">
		Índice de precipitação padronizada (SPI) - {{ periodoTitle }}
	</label>
</div>

<div
	*ngIf="carregando; else tabela"
	class="d-flex justify-content-center align-items-center w-100 h-50"
	style="min-height: 500px">
	<seira-loading [pageCentered]="false"></seira-loading>
</div>

<ng-template #tabela>
	<div
		style="max-width: 1300px"
		*ngIf="resultados.length > 0; else semDados"
		class="mt-3 mb-2">
		<seira-public-table
			#tabelaSpi
			id="tabela-SPI"
			[loading]="carregando"
			[searching]="false"
			[info]="false"
			[hasHeader]="false"
			[order]="[1, 'asc']"
			[scrollX]="true"
			[data]="resultados"
			[columns]="colunasSPI">
		</seira-public-table>
	</div>

	<seira-card-info [texto]="descricaoRelatorio" />
	<p class="referencia-estudo">
		{{ referenciaEstudo }}
	</p>
</ng-template>

<ng-template #semDados>
	<seira-sem-dados />
</ng-template>
